enum LogLevel {
  DEBUG = "DEBUG",
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
}

class Logger {
  private static instance: Logger;

  private constructor() {
    // Debug logging disabled
  }

  public static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  private formatMessage(
    level: LogLevel,
    message: string,
    ...args: unknown[]
  ): string {
    const timestamp = new Date().toISOString();
    const argsString = args.length
      ? ` ${args.map((arg) => String(arg)).join(" ")}`
      : "";
    return `[${timestamp}] [${level}] ${message}${argsString}`;
  }

  debug(_message: string, ..._args: unknown[]): void {
    // Debug logs disabled - uncomment below to enable
    // if (this.isDevelopment) {
    //   console.debug(this.formatMessage(LogLevel.DEBUG, message), ...args);
    // }
  }

  info(message: string, ...args: unknown[]): void {
    console.info(this.formatMessage(LogLevel.INFO, message), ...args);
  }

  warn(message: string, ...args: unknown[]): void {
    console.warn(this.formatMessage(LogLevel.WARN, message), ...args);
  }

  error(message: string, ...args: unknown[]): void {
    logger.error(this.formatMessage(LogLevel.ERROR, message), ...args);
  }
}

// Export a singleton instance
export const logger = Logger.getInstance();
